var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.2C12.8 15.2 12 16 12 17.2C12 18 12.6 18.6 13.2 18.8L12.6 21.6H15.2L14.6 18.8C15.4 18.6 15.8 18 15.8 17.2C16 16 15.2 15.2 14 15.2ZM14.2 6.6C12.8 6.6 11.4 7.6 11.4 9V12H16.8V9C16.6 7.6 15.6 6.6 14.2 6.6ZM14 0L0 6V12C0.2 20.8 5.8 28.6 14 31.8C22.2 28.6 27.8 20.8 28 12V6L14 0ZM22 22C22 23.2 21.2 24 20 24H8C6.8 24 6 23.2 6 22V14C6 12.8 6.8 12 8 12H8.6V9C8.8 6.2 11.2 4 14 4C16.8 4 19.2 6.2 19.4 9V12H20C21.2 12 22 12.8 22 14V22Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPrivacy);
export default __webpack_public_path__ + "static/media/dataPrivacy.4ff291cb8f59da497a96b85fee51df8a.svg";
export { ForwardRef as ReactComponent };